import { createContext } from 'react';
import type { AutomationPageV2Store } from './store';

export const AutomationPageV2StoreContext =
	createContext<AutomationPageV2Store | null>(null);
